import { Component, computed, input, output } from '@angular/core';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { AppServicesConfig, AppServicesConfigStatus } from '@keeps-platform-frontend-workspace/kp-keeps';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'kp-app-services-config',
  templateUrl: './kp-app-services-config.component.html',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatSlideToggle,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    TranslocoPipe,
  ],
})
export class KpAppServicesConfigComponent {
  appServicesConfig = input<AppServicesConfig>();
  workspaceId = input<string>();
  appStatusChanged = output<AppServicesConfigStatus>();

  protected readonly dataSource = computed(() => Object.keys(this.appServicesConfig() || {}));
  protected readonly displayedColumns = ['services', 'action'];

  onChangeAppStatus({ checked }: MatSlideToggleChange, service: string): void {
    const workspaceId = this.workspaceId();
    this.appStatusChanged.emit({ checked, service, workspaceId });
  }
}
